import { Axios } from "@lib";
import type { ChecklistAnswerSectionRequest } from "../types";

export async function checklistAnswerSection(
	payload: ChecklistAnswerSectionRequest
) {
	const { answerId, ...body } = payload;

	const { data } = await Axios.put(
		`/api/checklist/answer/${answerId}/section`,
		body
	);

	return data;
}
